import { execOnLoad } from '@general/helpers';
import { throttle } from 'lodash';
import './header.scss';
import { closeModal, openModal } from '@components/modals';
import { afterCartChangeType, getCart } from '@services/cart';

if (!window.dAgency) window.dAgency = {};
window.dAgency.initHeader = (context) => {
  const sectionContainer = context.classList.contains('shopify-section')
    ? context
    : context.closest('.shopify-section');
  if (!sectionContainer) return;

  const backgroundContainer = sectionContainer.querySelector(
    '.header__background',
  );
  const headerWrapper = sectionContainer.querySelector('.header__wrapper');
  if (backgroundContainer) {
    const resizeCallback = throttle(
      () =>
        document.documentElement.style.setProperty(
          '--header-height',
          `${backgroundContainer.clientHeight}px`,
        ),
      500,
    );
    resizeCallback();
    window.addEventListener('resize', resizeCallback);

    const announcementBarHeight =
      document.documentElement.style.getPropertyValue(
        '--announcement-bar-height',
      );
    const scrollOffset = announcementBarHeight
      ? parseInt(announcementBarHeight.replace('px', ''))
      : 0;

    let lastScrollTop = window.scrollY;
    if (
      typeof backgroundContainer.dataset.transparent !== 'undefined' ||
      typeof backgroundContainer.dataset.expanded !== 'undefined'
    ) {
      const scrollCallback = throttle(() => {
        if (sectionContainer.querySelector('.mobile-menu__container.open'))
          return;
        if (typeof backgroundContainer.dataset.transparent !== 'undefined') {
          backgroundContainer.dataset.transparent =
            window.scrollY <= scrollOffset;
        } else {
          let currentScroll = window.scrollY;

          if (currentScroll !== 0) {
            backgroundContainer.dataset.expanded =
              currentScroll < lastScrollTop;
          } else {
            backgroundContainer.dataset.expanded = true;
          }

          lastScrollTop = currentScroll;
        }
      }, 200);
      scrollCallback();
      window.addEventListener('scroll', scrollCallback);
    }
  }

  const cartIcon = sectionContainer.querySelector('.header__action--cart');
  const minicart = document.querySelector('#MinicartDrawer');
  if (cartIcon && minicart)
    cartIcon.addEventListener('click', (e) => {
      e.preventDefault();
      openModal(minicart);
    });

  const cartCounter = sectionContainer.querySelector(
    '.header__action-cart-counter',
  );
  if (cartCounter) {
    document.addEventListener(afterCartChangeType, async () => {
      const cart = await getCart();
      if (cart) cartCounter.innerText = cart.item_count;
    });
  }

  const searchWrapper = sectionContainer.querySelector('.header__search');
  const searchIcon = sectionContainer.querySelector('.header__action--search');
  const searchPreview = sectionContainer.querySelector(
    '.header-search-bar__intro',
  );
  const searchIconClose = document.querySelector('.header__search-close');
  if (searchWrapper && searchIcon) {
    const mainInput = searchWrapper.querySelector('input[name="q"]');
    const closeWrapper = searchWrapper.querySelector('.header__search-close');
    if (mainInput && closeWrapper) {
      const closeSearch = () => {
        headerWrapper.dataset.searchOpen = 'false';
        mainInput.value = '';
        mainInput.dispatchEvent(new Event('input', { bubbles: true }));
        searchPreview.style.display = 'none';
        searchIconClose.style.display = 'none';
      };
      closeWrapper.addEventListener('click', closeSearch);
      searchIcon.addEventListener('click', (e) => {
        e.preventDefault();
        if (headerWrapper.dataset.searchOpen == 'true') {
          closeSearch();
        } else {
          headerWrapper.dataset.searchOpen = 'true';
          searchPreview.style.display = 'flex';
          searchIconClose.style.display = 'flex';
          mainInput.focus();

          const openMobileMenu = sectionContainer.querySelector(
            '.mobile-menu__container',
          );
          if (openMobileMenu) {
            const modal = openMobileMenu.querySelector('.modal');
            openMobileMenu.classList.remove('open');
            closeModal(modal);
          }
        }
      });
    }
  }
};

execOnLoad(window.dAgency.initHeader, '.header__section');
